module.exports = ":host {\n  display: block;\n  width: 100%; }\n\n.search-typeahead {\n  width: 100%;\n  min-width: 240px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/search-typeahead/search-typeahead.component.scss
// module id = ./src/app/shared/search-typeahead/search-typeahead.component.scss
// module chunks = main